<template>
  <CRow>
    <CCol col="12" sm="12">
      <CCard>
        <CCardHeader>
          {{ $route.name }}
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol col="12" sm="5">
              <CInput
                :placeholder="$t('search_a') + $t('name')"
                v-model="searchData.name"
              />
            </CCol>
            <CCol col="12" sm="5">
              <CInput
                :placeholder="$t('search_a') + $t('email')"
                v-model="searchData.email"
              />
            </CCol>
            <CCol col="12" sm="2">
              <CButton color="primary" block @click="getAdmins()">{{ $t('search') }}</CButton>
            </CCol>
          </CRow>
          <hr>
          <CRow>
            <CCol col="12" sm="10" class="d-flex align-items-center">
              <font class="text-muted">{{ $t('search_info', searchInfo) }}</font>
            </CCol>
            <CCol col="12" sm="2">
              <CButton color="info" block @click="() => createAdminModal = { modal: true }">{{ $t('create_account') }}</CButton>
            </CCol>
          </CRow>
          <hr>
          <v-client-table :columns="columns" :data="data" :options="options">
            <CBadge slot="enabled" slot-scope="props" :color="$_.find(enabledOptions, option => { return option.value === props.row.enabled }).color">
              {{ $_.find(enabledOptions, option => { return option.value === props.row.enabled }).label }}
            </CBadge>
            <font slot="created_at" slot-scope="props">
              {{ $moment(props.row.created_at).format('YYYY-MM-DD HH:mm:ss') }}
            </font>
            <div slot="action" slot-scope="props" class="text-center">
              <CButtonGroup>
                <CButton color="warning" v-bind="{ variant: 'outline' }" @click="() => editAdminModal = { data: props.row, modal: true }">{{ $t('edit') }}</CButton>
              </CButtonGroup>
            </div>
          </v-client-table>
        </CCardBody>
      </CCard>

      <CreateAdminModal :data="createAdminModal.data" :show="createAdminModal.modal" @showUpdate="show => createAdminModal.modal = show" @formSubmit="getAdmins()" />

      <EditAdminModal :data="editAdminModal.data" :show="editAdminModal.modal" @showUpdate="show => editAdminModal.modal = show" @formSubmit="getAdmins()" />

    </CCol>
  </CRow>
</template>

<script>
import CreateAdminModal from './modal/CreateAdminModal'
import EditAdminModal from './modal/EditAdminModal'

export default {
  name: 'admins',
  components: {
    CreateAdminModal,
    EditAdminModal,
  },
  data () {
    return {
      columns: [ 'name', 'email', 'enabled', 'created_at', 'action' ],
      data: [],
      options: {
        headings: {
          name: this.$t('name'),
          email: this.$t('email'),
          enabled: this.$t('enable'),
          created_at: this.$t('create_time'),
          action: this.$t('action')
        },
        sortable: [ 'name', 'email', 'created_at', 'enabled' ],
        filterable: [ 'name', 'email', 'created_at', 'enabled' ]
      },
      enabledOptions: [
        { value: null, label: this.$t('please_select_a') + this.$t('enable') + '...' },
        { value: 1, label: this.$t('enable'), color: 'success' },
        { value: 0, label: this.$t('disable'), color: 'secondary' }
      ],
      searchInfo: { at: '-', count: 0, sec: 0 },
      searchData: { name: '', email: '' },
      createAdminModal: { data: {}, modal: false },
      editAdminModal: { data: {}, modal: false },
    }
  },
  computed: {
  },
  mounted: function () {
    this.getAdmins()
  },
  methods: {
    getAdmins () {
      const startMoment = this.$moment()
      const loader = this.$loading.show()
      this.$store.dispatch('getAdmins', this.$_.clone(this.searchData)).then(res => {
        this.data = res
        this.searchInfo.at = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        this.searchInfo.count = res.length
        this.searchInfo.sec = this.$moment().diff(startMoment) / 1000
        loader.hide()
      }).catch(e => {
        this.$swal('Error', e.message ? e.message : e, 'error')
        loader.hide()
      })
    }
  }
}
</script>
